import { CALL_INTERNAL_API } from '../../middleware/authHeaders'
import { INTERNAL_API_ROOT } from '../../config/api'
import { errorNotification } from '../application/notifications'

// TYPES & ACTIONS
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'

export const GET_SEARCH_RESULTS_REQUEST = 'GET_SEARCH_RESULTS_REQUEST'
export const GET_SEARCH_RESULTS_SUCCESS = 'GET_SEARCH_RESULTS_SUCCESS'
export const GET_SEARCH_RESULTS_FAILURE = 'GET_SEARCH_RESULTS_FAILURE'

export const getSearchResults = term => dispatch => {
  dispatch({ type: SET_SEARCH_TERM, payload: { term } })
  dispatch({
    [CALL_INTERNAL_API]: {
      method: 'GET',
      endpoint: `${INTERNAL_API_ROOT}/admin/search/global?search=${term}`,
      types: [GET_SEARCH_RESULTS_REQUEST, GET_SEARCH_RESULTS_SUCCESS, GET_SEARCH_RESULTS_FAILURE],
    },
  }).then(response => {
    if (response.error) {
      dispatch(
        errorNotification({
          body: `Error searching Submittable`,
          dismissInSeconds: 10,
        })
      )
      dispatch({ type: GET_SEARCH_RESULTS_FAILURE })
    }
  })
}

// SELECTORS
export const selectSearch = state => state.submittable.search

// STATE
const INITIAL_STATE = {
  isFetching: false,
  results: {},
  term: '',
}

// REDUCERS
const search = (state = INITIAL_STATE, { type, payload } = {}) =>
  ({
    [SET_SEARCH_TERM]: (currentState, newPayload) => ({
      ...currentState,
      ...newPayload,
    }),
    [GET_SEARCH_RESULTS_REQUEST]: currentState => {
      return {
        ...currentState,
        isFetching: true,
        results: {},
      }
    },
    [GET_SEARCH_RESULTS_FAILURE]: currentState => {
      return {
        ...currentState,
        isFetching: false,
        results: {},
      }
    },
    [GET_SEARCH_RESULTS_SUCCESS]: (currentState, newPayload) => {
      const organizations = [...newPayload.results.filter(el => el.type === 'Publisher')]
      const users = [...newPayload.results.filter(el => el.type === 'User')]
      const submissions = [...newPayload.results.filter(el => el.type === 'Submission')]
      const emails = [...newPayload.results.filter(el => el.type === 'Email')]
      return {
        ...currentState,
        isFetching: false,
        results: {
          organizations,
          users,
          submissions,
          emails,
        },
        term: newPayload.search,
      }
    },
  }[type]?.(state, payload) || state)

export default search
